import clienteAxios from "../config/axios";

export async function getProviders () {
    return clienteAxios.get(`/proveedores`);
}

export async function getProveedorByNroCta (nroCta) {
    return clienteAxios.get(`/proveedor/nroCta/${nroCta}`);
}

export async function uploadProvider ( userID, userName) {
    return clienteAxios.post('/actualizar/proveedor', {userID, userName});
}